// var paywall = require("./lib/paywall");
// setTimeout(() => paywall(12712114), 5000);

require("component-responsive-frame/child");